// ProjectTable.js
import React from "react";
import "./CompleteProject.css";

const CompleteProject = () => {
  const projects = [
    {
      id: 1,
      name: "Construction of Pipe Distribution network for BLI Part-I St-II Ta.Paithan, Dist. Chhatrapati Sambhajinagar",
      region: "Chhatrapati Sambhajinagar",
      client: "WRD, Maharashtra",
      cost: "18.69 Cr.",
      remarks: "Completed within 51 days",
    },
    {
      id: 2,
      name: "Construction of Pipe Distribution network for Deogaan Rangari L.M.I. Project, Ta.Kannad, Dist. Chhatrapati Sambhajinagar",
      region: "Chhatrapati Sambhajinagar",
      client: "WRD, Maharashtra",
      cost: "29.39 Cr.",
      remarks: "Completed within tender period",
    },
    {
      id: 3,
      name: "Construction of Pipe Distribution network for BLI Part-II Km-01 to Km-11 Ta.Paithan, Dist. Chhatrapati Sambhajinagar",
      region: "Chhatrapati Sambhajinagar",
      client: "WRD, Maharashtra",
      cost: "35.22 Cr.",
      remarks: "90% Work completed without extension",
    },
    {
      id: 4,
      name: "Construction of different Water Conservation Schemes and Repairs to KT weirs and Percolation Tanks , Construction of CNB etc.",
      region: "Chhatrapati Sambhajinagar",
      client: "Water Conservation",
      cost: "+10.00 Cr",
      remarks: "Works Completed",
    },
    {
      id: 5,
      name: "Construction of Head Regulator @ RD11100M in Main Canal-1 of Brahmagavhan L.I. scheme Tq. Paithan, Dist. Chhatrapati Sambhajinagar",
      region: "Chhatrapati Sambhajinagar",
      client: "WRD, Maharashtra",
      cost: "1.84 Cr.",
      remarks: "Work Completed",
    },
    {
      id: 6,
      name: "Construction of Pipeline Distribution Network for Minor No 01 to Minor No 15 (Km01 to Km15) Canal No.2 of BLI Part-II Tal. Paithan, Dist. Chhatrapati Sambhajinagar",
      region: "Chhatrapati Sambhajinagar",
      client: "WRD, Maharashtra",
      cost: "30.82 Cr.",
      remarks: "70 % Work completed without extension",
    },
  ];

  const consultancyData = [
    {
      id: 1,
      name: "Design of Ganagapur Lift Irrigation Scheme and PDN at District-Chhatrapati Sambhajinagar",
      region: "Chhatrapati Sambhajinagar",
      client: "Shiva Structures Minor Irrig, Division 1, Chh.Sambhajinagar",
      cost: "202.47 Lakh",
      remarks:
        "Survey, Design, Vetting & DPR for LIS & PDN for 10000 Ha. (ICA) DPR Cost -",
    },
    {
      id: 2,
      name: "Survey, Planning Canal System of Gurukuni LIS Scheme, District Amrawati",
      region: "Amrawati",
      client: "Shiva Structures For Amrawati Irrig.Division Amrawati",
      cost: "62.26 Lakh",
      remarks: "Survey, Design & Estimation DPR Cost -",
    },
    {
      id: 3,
      name: "Survey Design of Pressurised Pipe Distribution Network of Usad Pikole with Pump House",
      region: "Konkan",
      client: "Irri. Project Construction Division Sawantwadi",
      cost: "25.00 Lakh",
      remarks: "Survey, Design, Estimation of PDN of 2250Ha. (ICA) DPR Cost -",
    },
    {
      id: 4,
      name: "Survey, Design of Pressurised Pipe Distribution Network of Kherda Pachod Scheme, Tq.Palthan",
      region: "Chhatrapati Sambhajinagar",
      client: "Minor irrigation Division No.1, Chh. Sambhajinagar",
      cost: "50.00 Lakh",
      remarks:
        "Survey, Design, Estimates of PDN of 1750Ha. (ICA) Cost -51.69 Cr",
    },
    {
      id: 5,
      name: "Survey, Design of PDN Bramhgavan Lift Irrigation scheme, Canal-1, Canal-2,Tq.Palthan, District - Chh Sambhajinagar",
      region: "Chhatrapati Sambhajinagar",
      client: "Minor irrigation Division No.1, Chh. Sambhajinagar",
      cost: "170.47 Lakh",
      remarks:
        "Survey, Design, Vetting & DPR for PDN of 12342Ha. (ICA) DPR Cost – 92 Cr",
    },
    {
      id: 6,
      name: "Survey, Design, Estimation of Pipe Distribution Network for Aalewadi, Tq. Jalgaon Jamod, Dist-Buldhana",
      region: "Buldhana",
      client: "Datta Infra for Minor Irrigation Division Buldhana",
      cost: "30.00 Lakh",
      remarks:
        "Survey, Design, Estimates of PDN of 1750Ha. (ICA) Cost -51.69 Cr",
    },
    {
      id: 7,
      name: "Construction of Pressureised Pipeline Distribution Network from Tillari Main Canal to Zare-Pikule Khokral-Usap, Ta.Dodamarg Dist. Sindhudurga",
      region: "Sindhudurga",
      client: "Sindhudurg Irrigation Project Construction Division, Sawantwadi",
      cost: "25.00 Lakh",
      remarks:
        "Survey, Design, Estimation, Vetting & DPR for PDN for 758 Ha. (ICA) DPR Cost – 44.00 Cr",
    },
    {
      id: 8,
      name: "Survey, Planning, Design of Gurukuni LIS Scheme, District Amrawati",
      region: "Amravati",
      client: "LCC , Ahmadabad",
      cost: "0.60 Cr.",
      remarks: "Survey, Design & Estimation DPR Cost -",
    },
  ];

  const barrageProjects = [
    {
      id: 1,
      name: "Survey, Hydraulic Study, Design, Estimate & DPR of Barrages on Purna River Ta. Sillod, Dist Chhatrapati Sambhajinagar",
      region: "Chhatrapati Sambhajinagar",
      client: "Minor Irrigation Division No.1 Chhatrapati Sambhajinagar",
      cost: "46.97 Lakh",
      remarks: "DPR Sanctioned Cost – 534.92 CR",
    },
    {
      id: 2,
      name: "Survey, Planning, Design of Ghungshi Barrage , District Akola",
      region: "Amravati",
      client: "VUB Engineering, Mumbai",
      cost: "40.00 Lakh",
      remarks: "Survey, Design & Estimation DPR Cost -",
    },
    {
      id: 3,
      name: "Survey for High level Barrages on Krushna River at District Satara.",
      region: "Satara",
      client: "Jivhe Kathapur Con.Division Satara",
      cost: "30.00 Lakh",
      remarks: "Work in progress",
    },
    {
      id: 4,
      name: "Survey, Investigation, Hydraulic Study, Design and Estimation of Barrages/KT Weirs on Tukur River Tq, Dist-Beed",
      region: "Beed",
      client: "Beed Irrigation Division, Beed",
      cost: "20.00 Lakh",
      remarks: "Work Complete DPR Submitted 9 Structures 220 Cr",
    },
    {
      id: 5,
      name: "Survey work of Penganga river High level Barrages at Pangra (Sapit), Gojegaon, Banchincholi, Ghaarapur, Maregaon and Dhanoda District Nanaded",
      region: "Nanded",
      client: "NIC, CADA Chhtrapati Sambhajinagar",
      cost: "20.67 Lakh",
      remarks: "Work Complete",
    },
    {
      id: 6,
      name: "Preliminary Survey new bandharas on tema river from Ratnapur to gaur village, Tq-Kalamb, Dist-Dharashiv.",
      region: "Beed",
      client: "Krushna Marathwada Construction Division No.1, Dharashiv.",
      cost: "10.00 Lakh",
      remarks: "Work Complete DPR Submitted 7 Structures for 74 Cr",
    },
    {
      id: 7,
      name: "Survey, Design and Estimation work of Protection wall on Rivers of Godawari and Tapi Basin, Tq.Kannad, District Chhatrapati Sambhajinagar.",
      region: "Chhatrapati Sambhajinagar",
      client: "Minor Irrigation Division No.1 Chhatrapati Sambhajinagar",
      cost: "20.00 Lakh",
      remarks: "Proposal Sanctioned Cost – 32.00 Cr",
    },
       {
      id: 8,
      name: "Preparation and implementation of EAP Work for Wakod MI, Titwi MI, Sonkheda MI, Patoda MI, Khoradsawangi MI, Plalskheda MI, Aruna MI",
      region: "Marathwada, Pune, Konkan",
      client: "WRD, Maharashtra",
      cost: "23.95 Lakh",
      remarks: "All EAPs Approved By Chief Engineer",
    },
           {
      id: 9,
      name: "Computation of Red Line and Blue line and demarcation works of Rena, Terna, Kham, Shivna Takli, Anjana, Ambadi, Purna & Waghur, Khelana Other Rivers  ",
      region: "Chhatrapati Sambhajinagar",
      client: "CADA & WRD, Chhatrapati Sambhajinagar",
      cost: "+100 Lakh",
      remarks: "Red Line Blue Line Approved By Chief Engineer",
    },
  ];

  return (
    <div>
      <div className="project-table-container">
        <h2>MAJOR PROJECTS - CONSTRUCTION</h2>
        <div className="table-wrapper">
          <table className="project-table">
            <thead>
              <tr>
                <th>Sr.No.</th>
                <th>Name of Project</th>
                <th>Region</th>
                <th>Client</th>
                <th>Cost of Construction</th>
                <th>Remarks</th>
              </tr>
            </thead>
            <tbody>
              {projects.map((project) => (
                <tr key={project.id}>
                  <td data-label="Sr.No.">{project.id}</td>
                  <td data-label="Name of Project">{project.name}</td>
                  <td data-label="Region">{project.region}</td>
                  <td data-label="Client">{project.client}</td>
                  <td data-label="Cost of Construction">{project.cost}</td>
                  <td data-label="Remarks">{project.remarks}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      <div className="consultancy-container">
        <h2>MAJOR PROJECTS - LIS & PDN CONSULTANCY</h2>
        <div className="consultancy-table-wrapper">
          <table className="consultancy-table">
            <thead>
              <tr>
                <th>Sr.</th>
                <th>Name of Project</th>
                <th>Region</th>
                <th>Client</th>
                <th>Cost of Consultancy</th>
                <th>Remarks</th>
              </tr>
            </thead>
            <tbody>
              {consultancyData.map((project) => (
                <tr key={project.id}>
                  <td data-label="Sr.">{project.id}</td>
                  <td data-label="Name of Project">{project.name}</td>
                  <td data-label="Region">{project.region}</td>
                  <td data-label="Client">{project.client}</td>
                  <td data-label="Cost of Consultancy">{project.cost}</td>
                  <td data-label="Remarks">{project.remarks}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

        <div className="barrage-projects-container">
      <h2>MAJOR PROJECTS – BARRAGES</h2>
      <div className="barrage-table-container">
        <table className="barrage-projects-table">
          <thead>
            <tr>
              <th>Sr. No.</th>
              <th>Name of Project</th>
              <th>Region</th>
              <th>Client</th>
              <th>Cost of Consultancy</th>
              <th>Remarks</th>
            </tr>
          </thead>
          <tbody>
            {barrageProjects.map(project => (
              <tr key={project.id}>
                <td data-label="Sr. No.">{project.id}</td>
                <td data-label="Name of Project">{project.name}</td>
                <td data-label="Region">{project.region}</td>
                <td data-label="Client">{project.client}</td>
                <td data-label="Cost of Consultancy">{project.cost}</td>
                <td data-label="Remarks">{project.remarks}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
    </div>
  );
};

export default CompleteProject;
